module.exports = __webpack_public_path__ + "static/img/SV.64fd671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/SV.png
// module id = 8Syi
// module chunks = 9